import { A4uVolumeThree as IconComponent } from '@adobe/react-spectrum-workflow/dist/VolumeThree.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function VolumeThree(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}